import React from 'react';
import PropTypes from 'prop-types';

const PostImage = (props) => {
  const { contentItem } = props;
  return (
    <div
      className={`post-item post-img ${contentItem.classes ? contentItem.classes.join(' ') : ''}`}
      id={contentItem.id ? contentItem.id : null}
    >
      <figure className="post-img__inner">
        <img
          height={contentItem.height ? contentItem.height : ''}
          width={contentItem.width ? contentItem.width : ''}
          src={contentItem.src}
          srcSet={contentItem.srcset ? contentItem.srcset : ''}
          sizes={contentItem.sizes ? contentItem.sizes : ''}
          alt=""
        />
      </figure>
    </div>
  );
};

PostImage.propTypes = {
  contentItem: PropTypes.shape({
    classes: PropTypes.arrayOf(PropTypes.string),
    id: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string,
    sizes: PropTypes.string,
  }).isRequired,
};

export default PostImage;



// WEBPACK FOOTER //
// ./src/components/PostImage.js